import React, { useEffect, useState } from 'react'
import { ClassNames } from '../../../helper';

const CustomizeNudgeStats = ({usersNudgeData, userPersonaTypes}) => {
    // console.log("------usersNudgeData-------", usersNudgeData);
    const [nudgeStat, setNudgeStat] = useState({});

    const getOptionName = (key) => {
        return userPersonaTypes.find(persona => persona.optionValue === key)?.optionName || '';
    }

    const getNudgeStats = (nudgeData) => {
        let temp = {};
        for (let [key, val] of Object.entries(nudgeData)) {
            let title = getNudgeTitle(getOptionName(key));
            let active = getNudgeStatus(val);
            let couponCode = getCouponCode(val);
            temp[key] = { title, active, couponCode };
        }
        return temp;
    };

    const getNudgeTitle = (nudgeTitle) => {
        return nudgeTitle?.replace(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/, "");
    }

    const getNudgeStatus = (nudgeData) => {
        let status = nudgeData?.nudgeShowing?.customizeProperties?.status?.propertyValue;
        return status === "ON";
    }

    const getCouponCode = (nudgeData) => {
        return nudgeData?.nudgeCouponCode?.customizeProperties?.text?.propertyValue || '';
    }
    
    useEffect(() => {
        if (Object.keys(usersNudgeData).length === 0) return;
        let result = getNudgeStats(usersNudgeData)
        setNudgeStat(result)
    }, [usersNudgeData])

    return (
        <div className='bg-white m-5 mt-1 border rounded-md shadow-md p-4'>
            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-300 border rounded-lg">
                    <thead>
                        <tr className="divide-x divide-gray-300">
                            <th
                                scope="col"
                                className="py-3.5 px-2 text-left text-sm font-semibold text-gray-900"
                            >
                                Persona Name
                            </th>
                            <th
                                scope="col"
                                className="py-3.5 px-2 text-center text-sm font-semibold text-gray-900"
                            >
                                Coupon Code
                            </th>
                            <th
                                scope="col"
                                className="px-2 py-3.5 text-center text-sm font-semibold text-gray-900"
                            >
                                Status
                            </th>
                            {/* <th
                                scope="col"
                                className="px-2 py-3.5 text-center text-sm font-semibold text-gray-900"
                            >
                                Details
                            </th> */}
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-300 bg-white">
                        {Object.values(nudgeStat)?.map((persona) => (
                            <tr key={persona.title} className="divide-x divide-gray-300">
                                <td className="whitespace-nowrap p-2 text-sm font-medium text-gray-900">
                                    {persona.title}
                                </td>
                                <td className="whitespace-nowrap p-2 text-sm text-center text-blue-700">
                                    {persona.couponCode}
                                </td>
                                <td className={ClassNames(
                                    "whitespace-nowrap p-2 text-sm text-center",
                                    persona.active ? "text-green-600" : "text-red-600"
                                )}>
                                    {persona.active ? "Enabled" : "Disabled"}
                                </td>
                                {/* <td className="whitespace-nowrap p-2 text-sm text-center">
                                    <button disabled className='text-white bg-indigo-300 p-2 px-4 rounded-md cursor-not-allowed'>
                                        View More
                                    </button>
                                </td> */}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default CustomizeNudgeStats